module.exports = __webpack_public_path__ + "media/images/v2/streaming_white-2e5f4f107d597e49f016791448dc3b29.png";